import { Pipe, PipeTransform } from '@angular/core';
import { ORGANIASTION_IDENTIFIER_LOOKUP } from '@flyfreely-portal-ui/flyfreely';

/**
 * Formats the integration name
 */
@Pipe({
    name: 'formatOrganisationIntegration'
})
export class FormatOrganisationIntegrationPipe implements PipeTransform {
    transform(value: string): string {
        return ORGANIASTION_IDENTIFIER_LOOKUP[value] ?? value;
    }
}
